import { default as deserialize } from 'app/utils/deserialize'
import { fetch, create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: [],
    payments: []
  },

  getters: {
    currentPurchases: (state) => state.list,
    currentPayments: (state) => state.payments
  },

  mutations: {
    purchasesFetched(state, { purchases }) {
      state.list = purchases
    },

    paymentsFetched(state, { payments }) {
      state.payments = payments
    }
  },

  actions: {
    async fetchPurchases({ commit }) {
      const response = await fetch({
        url: '/api/admin/affiliate-purchases'
      })

      const purchases = await deserialize(response.data)

      commit('purchasesFetched', { purchases })
    },

    async fetchFilteredPurchases({ commit }, filters) {
      const response = await fetch({
        url: '/api/admin/affiliate-purchases',
        params: filters
      })

      const purchases = await deserialize(response.data)

      commit('purchasesFetched', { purchases })
    },

    async fetchPayments({ commit }, dates) {
      const response = await fetch({
        url: '/api/admin/affiliate-complete-payments',
        params: dates
      })

      const payments = await deserialize(response.data)

      commit('paymentsFetched', { payments })
    },

    async sendFilteredPayment({ dispatch }, dates) {
      await create({
        url: '/api/admin/affiliate-purchases',
        data: dates
      })
    },

    async sendPayment() {
      await create({
        url: '/api/admin/affiliate-purchases',
        data: {}
      })
    }
  }
}
